// extracted by mini-css-extract-plugin
export default {"overlay":"SelectedDiffLinesOverlay-module__overlay--mWvvK","overlayOpacity":"SelectedDiffLinesOverlay-module__overlayOpacity--B9iKM"};